import React from 'react'

type ShuffleProps = React.SVGProps<SVGSVGElement> & {
  width?: number
  height?: number
  fill?: string
}

export const Shuffle = ({
  width = 17,
  height = 15,
  fill = '#889096',
  ...props
}: ShuffleProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3118 0.59375C13.6868 0.4375 14.1243 0.53125 14.4055 0.8125L16.4055 2.8125C16.593 3 16.718 3.25 16.718 3.5C16.718 3.78125 16.593 4.03125 16.4055 4.21875L14.4055 6.21875C14.1243 6.5 13.6868 6.59375 13.3118 6.4375C12.9368 6.28125 12.718 5.90625 12.718 5.5L12.718 4.5H11.718C11.3743 4.5 11.093 4.65625 10.9055 4.90625L9.59302 6.6875L8.34302 5L9.31177 3.71875C9.87427 2.96875 10.7493 2.5 11.718 2.5H12.718V1.5C12.718 1.125 12.9368 0.75 13.3118 0.59375ZM5.84302 8.34375L7.09302 10L6.09302 11.3125C5.53052 12.0625 4.65552 12.5 3.71802 12.5H1.71802C1.15552 12.5 0.718018 12.0625 0.718018 11.5C0.718018 10.9688 1.15552 10.5 1.71802 10.5H3.71802C4.03052 10.5 4.31177 10.375 4.49927 10.125L5.84302 8.34375ZM14.4055 14.2187C14.1243 14.5 13.6868 14.5937 13.3118 14.4375C12.9368 14.2812 12.6868 13.9062 12.6868 13.5V12.5H11.6868C10.7493 12.5 9.87427 12.0625 9.31177 11.3125L4.49927 4.90625C4.31177 4.65625 4.03052 4.5 3.71802 4.5L1.71802 4.5C1.15552 4.5 0.718018 4.0625 0.718018 3.5C0.718018 2.96875 1.15552 2.5 1.71802 2.5L3.71802 2.5C4.65552 2.5 5.53052 2.96875 6.09302 3.71875L10.9055 10.125C11.093 10.375 11.3743 10.5 11.718 10.5H12.718V9.5C12.718 9.125 12.9368 8.75 13.3118 8.59375C13.6868 8.4375 14.1243 8.53125 14.4055 8.8125L16.4055 10.8125C16.593 11 16.718 11.25 16.718 11.5C16.718 11.7812 16.593 12.0312 16.4055 12.2187L14.4055 14.2187Z"
        fill={fill}
      />
    </svg>
  )
}

export default Shuffle
